import { useTranslation } from 'react-i18next';

import { useProfiles } from '../../contexts/ProfileContext';

import { BehaviorTags } from './BehaviorTags';
import { Insights } from './Insights';
import { ProfileStats } from './ProfileStats';
import { PurchaseHistory } from './PurchaseHistory';
import { Username } from './Username';

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/Sheet';
import { useGetCrm } from '@/hooks/useGetCrm';

export function ProfileModal() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Profiles.components.ProfileModal',
  });

  const { crmId, viewCrm } = useProfiles();

  const { crm } = useGetCrm(crmId ?? 0);

  if (!crm) {
    return null;
  }

  return (
    <Sheet open={!!crmId} onOpenChange={() => viewCrm(null)}>
      <SheetContent className="w-full !max-w-[600px] overflow-scroll p-0">
        <SheetHeader className="border-b px-5 py-4">
          <SheetTitle className="text-lg font-medium">{t('title')}</SheetTitle>
          <SheetDescription className="hidden" />
        </SheetHeader>

        <div className="py-5">
          <div className="flex items-center justify-between gap-2 px-7 py-3">
            <Username crm={crm} />
            <BehaviorTags crm={crm} />
          </div>

          <div className="mb-5 px-5">
            <ProfileStats crm={crm} />
          </div>

          <PurchaseHistory crm={crm} />
        </div>

        {crm?.profile && (
          <div className="py-5">
            <Insights crm={crm} />
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
